import apiClient from './apiService';
import { parseFiltersToQueryString } from "../utils/parseFiltersToQueryString";

class GoalService {
  constructor() {
    if (GoalService.instance) {
      return GoalService.instance;
    }
    GoalService.instance = this;
  }

  /**
   * Obtiene todas las metas con filtros opcionales.
   * @returns {Promise<any>}
   */
  async getAll(filters = {}) {
    try {
      const queryString = parseFiltersToQueryString(filters);
      const response = await apiClient.get(`/goals?${queryString}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching goals:", error);
      throw error;
    }
  }

  /**
   * Obtiene una meta específica por ID.
   * @param {number} id
   * @returns {Promise<any>}
   */
  async get(id) {
    try {
      const response = await apiClient.get(`/goals/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching goal with ID ${id}:`, error);
      throw error;
    }
  }

  /**
   * Crea una nueva meta.
   * @param {Object} goalData
   * @returns {Promise<any>}
   */
  async create(goalData) {
    try {
      const response = await apiClient.post('/goals', goalData);
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw new Error("Error en la conexión con el servidor.");
    }
  }

  /**
   * Actualiza una meta existente.
   * @param {number} id
   * @param {Object} goalData
   * @returns {Promise<any>}
   */
  async update(id, goalData) {
    try {
      const response = await apiClient.put(`/goals/${id}`, goalData);
      return response.data;
    } catch (error) {
      console.error(`Error updating goal with ID ${id}:`, error);
      throw error;
    }
  }

  /**
   * Elimina una meta por ID.
   * @param {number} id
   * @returns {Promise<any>}
   */
  async delete(id) {
    try {
      await apiClient.delete(`/goals/${id}`);
      return { success: true, message: "Meta eliminada correctamente." };
    } catch (error) {
      console.error(`Error deleting goal with ID ${id}:`, error);
      throw error;
    }
  }

  /**
   * Singleton Instance
   */
  static getInstance() {
    if (!GoalService.instance) {
      GoalService.instance = new GoalService();
    }
    return GoalService.instance;
  }
}

export default GoalService.getInstance();
